// src/services/automationEfectoresService.js
import api from "./Api";

// Todas las rutas cuelgan de /api (o REACT_APP_API_URL) gracias a Api.js
const PATH = "/automatizacion-efectores";

// Listar reglas (filtros opcionales)
export const listarReglas = async (filters = {}) => {
  const { estanqueId, dispositivoId, efectorId, archivadas } = filters || {};
  const params = {};

  if (estanqueId !== undefined && estanqueId !== null && `${estanqueId}` !== "")
    params.estanqueId = estanqueId;
  if (dispositivoId !== undefined && dispositivoId !== null && `${dispositivoId}` !== "")
    params.dispositivoId = dispositivoId;
  if (efectorId !== undefined && efectorId !== null && `${efectorId}` !== "")
    params.efectorId = efectorId;
  if (archivadas) params.archivadas = true;

  const { data } = await api.get(`${PATH}/reglas`, { params });
  return data; // [{ id, efectorId, estaActivo, tipo, intervaloMin, ...}]
};

export const crearRegla = async (payload) => {
  const { data } = await api.post(`${PATH}/reglas`, payload);
  return data; // { id }
};

export const actualizarRegla = async (id, payload) => {
  const { data } = await api.put(`${PATH}/reglas/${id}`, payload);
  return data;
};

export const toggleRegla = async (id) => {
  const { data } = await api.patch(`${PATH}/reglas/${id}/toggle`, {});
  return data; // { estaActivo }
};

export const eliminarRegla = async (id) => {
  const { data } = await api.delete(`${PATH}/reglas/${id}`);
  return data;
};

export const archivarRegla = async (id) => (await api.post(`${PATH}/reglas/${id}/archivar`)).data;
export const recuperarRegla = async (id) => (await api.post(`${PATH}/reglas/${id}/recuperar`)).data;

const automationEfectoresService = {
  listarReglas,
  crearRegla,
  actualizarRegla,
  toggleRegla,
  eliminarRegla,
  archivarRegla,
  recuperarRegla,
};

export default automationEfectoresService;
